import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { GetDeviceDataHistoryListPagingAndFilterRequest } from '../models/request/deviceData/GetDeviceDataHistoryListPagingAndFilterRequest';

export class DeviceDataHistoryService {
    static async getDeviceHistoryBetweenTwoDates(_deviceId: string | null | undefined, _startDate: string | undefined, _endDate: string | undefined) {
        try {
            var inputObj = {
                deviceId: _deviceId,
                startDate: _startDate,
                endDate: _endDate
            }

            console.log('SERVICE CALL - GetDeviceHistoryBetweenTwoDates', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/DeviceDataHistory/GetDeviceHistoryBetweenTwoDates', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getDeviceDataHistoryListPagingAndFilter(inputObj: GetDeviceDataHistoryListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - getDeviceDataHistoryList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/DeviceDataHistory/GetDeviceDataHistoryListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}